// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accept-invitation {
  width: 100%;
  min-height: 100%;
  height: 100%;
  background: var(--color-background-layer-2);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/user-management/invitations/ui/AcceptInvitation.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,2CAAA;AACF","sourcesContent":[".accept-invitation {\n  width: 100%;\n  min-height: 100%;\n  height: 100%;\n  background: var(--color-background-layer-2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
